export enum RevenueRecognitionPeriod {
  CONTRACT_ACTIVATION = 'contractActivation',
  CUSTOM = 'custom',
}
